<div class="pure-g m-t-16" style="align-items: center; display: flex; justify-content: flex-end">
  <div class="pure-u-md-6-24 pure-u-lg-5-24 pure-u-xl-4-24 right">
    @if (isRepairPartAddEnabled()) {
      <mc-button
        label="Add New"
        routerLink="/master-data/repair-part/add-new"
        variant="filled"
        appearance="primary"
        fit="small"></mc-button>
    }
  </div>
</div>

<div class="filter-utility-row m-t-8">
  <div class="quick-filter-box">
    <div class="p-l-4 applied-filter-holder">
      @for (taggedFilter of taggedFilters; track taggedFilter.key) {
        <div class="m-r-4" style="white-space: nowrap">
          {{ taggedFilter.key }}
        </div>

        @if (taggedFilter.key == 'Mode' && getTaggedMode().length > 0) {
          <app-tag-with-overflow [data]="getTaggedMode()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectModeByValue">
          </app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Repair Code' && getTaggedRepairCode().length > 0) {
          <app-tag-with-overflow
            [data]="getTaggedRepairCode()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectRepairCodeByValue">
          </app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Part Number' && getTaggedPartNumber().length > 0) {
          <app-tag-with-overflow
            [data]="getTaggedPartNumber()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectPartNumberByValue">
          </app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Max Part Qty' && !isArrayType(taggedFilter.value)) {
          <mc-tag
            class="m-r-4 extra-height"
            appearance="neutral-inverse"
            fit="small"
            padding="compact"
            withaction
            (dismiss)="unselectSpecificFilter(taggedFilter)">
            {{ taggedFilter.value }}
          </mc-tag>
        }
      }
      @if (taggedFilters.length > 0) {
        <a>
          <mc-button
            class="clear-btn"
            variant="plain"
            appearance="primary"
            fit="small"
            padding="default"
            (click)="clearAllSelectedFilters()"
            (keydown.enter)="clearAllSelectedFilters()"
            (keydown.space)="$event.preventDefault(); clearAllSelectedFilters()">
            Clear All
          </mc-button>
        </a>
      }
    </div>
    <div class="utility-buttons">
      @if (canViewRepairPartDownload) {
        <mc-button
          class="utility-button"
          label="Button"
          variant="filled"
          appearance="neutral"
          fit="medium"
          icon="tray-arrow-down"
          hiddenlabel
          padding="default"
          [loading]="isDownload"
          (click)="onDownload()"
          (keydown.enter)="onDownload()"
          (keydown.space)="$event.preventDefault(); onDownload()">
        </mc-button>
      }

      <mc-button
        class="utility-button-inner"
        slot="trigger"
        label="Button"
        icon="sliders-horizontal"
        variant="filled"
        appearance="neutral"
        hiddenlabel
        padding="default"
        fit="medium"
        (click)="showAdvanceFiltersModal()"
        (keydown.enter)="showAdvanceFiltersModal()"
        (keydown.space)="$event.preventDefault(); showAdvanceFiltersModal()">
      </mc-button>
    </div>
  </div>

  @if (showAdvanceFilters) {
    <mc-modal
      backdropcloseactiondisabled
      [open]="showAdvanceFilters"
      (closed)="closeAdvanceFiltersModal()"
      heading="Filters"
      fit="small"
      dimension="large">
      <app-repair-part-advance-filter
        [bindMultiSelects]="showAdvanceFilters"
        [repairPartFilterForm]="filterFormGroup.controls.repairPartFilterForm"></app-repair-part-advance-filter>
    </mc-modal>
  }
</div>
